



























import * as R from 'ramda';
import { computed, defineComponent } from '@vue/composition-api';
import { useSampleFields } from '../composable';
import { ChevronRightIcon } from '@vue-hero-icons/outline';

export default defineComponent({
    name: 'SampleValues',
    components: { ChevronRightIcon },
    props: {
        fields: {
            type: Array,
            required: true,
        },
        sample: {
            type: Array,
            required: true,
        },
        previousStepSample: {
            type: Array,
            default: null,
        },
        size: {
            type: Number,
            default: 20,
        },
    },
    setup(props) {
        const { extractFieldSample } = useSampleFields();

        const fieldsSample = computed(() => {
            if (props.sample) {
                return props.fields.map((field: any) => {
                    const col: any = R.pick(['title', 'path', 'order', 'type'], field);
                    if (props.previousStepSample) {
                        col.sample = extractFieldSample(props.previousStepSample, field.title, field.path);
                    } else {
                        col.sample = extractFieldSample(props.sample, field.originalName, field.originalPath);
                    }
                    return col;
                });
            }
            return [];
        });

        return { fieldsSample };
    },
});
